module.exports = __webpack_public_path__ + "img/Icon-TaskPresents.7486aca0.svg";